import { render, staticRenderFns } from "./master-payment-partner.vue?vue&type=template&id=1edaf9d7"
import script from "./master-payment-partner.vue?vue&type=script&lang=js"
export * from "./master-payment-partner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports